import React from 'react';
import Header from "../Header";
import Banner from '../Banner';
import Blog from '../Blog';
import Feature from '../Feature';
import HowItWorksTwo from '../how-it-works';
import Footer from '../Footer';
import ScrollToTopButton from '../../Components/Theme/Theme';
import RendezVous1 from '../../Components/frontend/rendez-vous/rendez-vous5';



function Rendez_vous3() {
    return (
        <>
            <Header></Header>
            <RendezVous1></RendezVous1>
            <Footer></Footer>                      
            <ScrollToTopButton></ScrollToTopButton>                      
        </>
    );
}

export default Rendez_vous3;
